import { gql } from '@apollo/client';
import { FilterInput } from '@/components/publicSearch/constants';
import type { GridSortModel } from '@mui/x-data-grid-pro';
/** GraphQL input shape for grouped filters (logicalOperator is AND/OR strings). */
type SharedSearchFilterGroupInputWire = {
  logicalOperator: string;
  filters: FilterInput[];
};

type SharedSearchFilterCondition = {
  field: string;
  operator: string;
  value: string;
};

type SharedSearchSortItem = {
  field: string;
  sort?: string | null;
};

type SharedSearchFilterGroupGql = {
  filters: SharedSearchFilterCondition[];
  logicalOperator: string;
};

export type SharedSearchResult = {
  shortCode: string;
  searchType: string;
  filters: SharedSearchFilterCondition[];
  commonFilterOperator: string;
  searchTerm: string;
  gridSortModel: SharedSearchSortItem[];
  isAiMode: boolean;
  filterGroups: SharedSearchFilterGroupGql[];
  groupsOperator: string;
  aiSearchPrompt: string;
};

type CreateSharedSearchInput = {
  searchType: string;
  filters: FilterInput[];
  commonFilterOperator: string;
  searchTerm: string;
  gridSortModel: GridSortModel;
  isAiMode: boolean;
  filterGroups: SharedSearchFilterGroupInputWire[];
  groupsOperator: string;
  aiSearchPrompt: string;
};

export type CreateSharedSearchResponse = {
  createSharedSearch: {
    shortCode: string;
    searchType: string;
  };
};

export type CreateSharedSearchVariables = {
  societyId: number;
  input: CreateSharedSearchInput;
};

export const CREATE_SHARED_SEARCH = gql`
  mutation CreateSharedSearch(
    $societyId: Int!
    $input: CreateSharedSearchInput!
  ) {
    createSharedSearch(societyId: $societyId, input: $input) {
      shortCode
      searchType
    }
  }
`;
